module.exports = __webpack_public_path__ + "static/media/charity-donations.5a44c7da.svg";